var helpers = {
    numberToString: function (value, allowFormat) {
        if (!allowFormat) {
            return String(value);
        }
        return value.toLocaleString('de-DE');
    },
    stringToNumber: function (value) {
        return Number(value
            .replace(/_/g, '')
            .replace(/[\.,]/g, function (char) { return (char === '.' ? '' : '.'); }));
    },
};
export default helpers;
